module.exports = __webpack_public_path__ + "static/logo-4fb38cb7968365a20503e96930b021d0.png";